import { AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';
import api from '../../Axios/middleware';
import { failureGetParkingType, successGetParkingType } from './ParkTypeSlicer';
import { PayloadAction } from '@reduxjs/toolkit';

const ParkingTypeApi = (action: PayloadAction<any>) => {
  return api.get(`/parking-type/${action.payload}`);
};

export function* ParkingTypeCall(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse = yield call(ParkingTypeApi, action);
    yield put(successGetParkingType(response.data));
    
  } catch (error) {
    yield put(failureGetParkingType(error));
  }
}
